import React from "react";
import PropTypes from "prop-types";
import statusUtils from "../../utils/statusUtils";
import { useSelector } from "react-redux";
import "../../styles/StatusBadge.css";

const StatusBadge = ({
  status,
  size = "medium",
  showIcon = true,
  isGrant = false,
}) => {
  const { user } = useSelector((state) => state.grievances);
  const userRole = user?.role;

  if (!status) {
    return null;
  }

  let statusName = status;
  let statusId = status;

  if (typeof status === "object") {
    statusId = status.statusId || status.STATUS_ID;
    statusName =
      status.statusName ||
      status.STATUS_NAME ||
      status.status ||
      "Unknown Status";
  }

  if (typeof statusId === "string" && /^\d+$/.test(statusId)) {
    if (isGrant && parseInt(statusId) < 10) {
      statusId = statusUtils.mapLegacyToGrantStatus(statusId);
    }

    statusName = statusUtils.getStatusName(statusId, userRole);
  }

  const { className, icon } = statusUtils.getStatusStyle(statusName);

  const sizeClass = `status-badge-${size}`;

  return (
    <div className={`status-badge ${className} ${sizeClass}`}>
      {showIcon && <i className={`bi ${icon}`}></i>}
      <span style={{ color: "#000" }}>
        {statusName.length > 10 ? statusName.slice(0, 20) + "..." : statusName}
      </span>
    </div>
  );
};

StatusBadge.propTypes = {
  status: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
    PropTypes.object,
  ]).isRequired,
  size: PropTypes.oneOf(["small", "medium", "large"]),
  showIcon: PropTypes.bool,
  isGrant: PropTypes.bool,
};

export default StatusBadge;
